var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdMenuModule, MdListModule } from '@angular/material';
import { TdMenuComponent } from './menu.component';
var TD_MENU = [
    TdMenuComponent,
];
export { TdMenuComponent } from './menu.component';
var CovalentMenuModule = (function () {
    function CovalentMenuModule() {
    }
    return CovalentMenuModule;
}());
CovalentMenuModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            MdMenuModule,
            MdListModule,
        ],
        declarations: [
            TD_MENU,
        ],
        exports: [
            TD_MENU,
        ],
    })
], CovalentMenuModule);
export { CovalentMenuModule };
//# sourceMappingURL=menu.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/menu/menu.module.js
// module id = ../../../../@covalent/core/menu/menu.module.js
// module chunks = 4